<template>
  <span>
    <font-awesome-icon icon="download" class="ln-primary mr-2" />
    <a href="javascript:void(0);" class="text-dark" @click="downloadFile"
      >Atsisiųsti aktą byloje</a
    >
  </span>
</template>

<script>
import { FileRepo } from "../../_Services/repository";
import generateFileName from '../../_Helpers/generate-file-name.js';
export default {
  name: "btn-document-download",
  props: {
    documentMeta: {
      type: Object,
      required: true,
    },
  },
  methods: {
    downloadFile() {
      //console.log(this.documentMeta.guid);
      FileRepo.get(this.documentMeta.guid)
        .then((res) => {
          this.forceFileDownload(res);
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    forceFileDownload(response) {
      let contentDisposition = response.headers["content-disposition"];
      let filename = "file.unkw";
      if (contentDisposition == null) {
        var mime = require("mime-types");
        let contentType = response.headers["content-type"];
        let extention = mime.extension(contentType);
        filename = extention ? `file.${extention}` : "file.adoc";
      } else {
        filename = generateFileName(this.documentMeta);
      }
      let blob = new Blob([response.data]);
      if (window.navigator && window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      }
    },
  },
};
</script>

<style scoped></style>
